import { useFormContext } from "react-hook-form";
import { useRef, useState, MouseEvent, KeyboardEvent } from "react";
import axios from "axios";
import Input from "../../../UI/Input";
import SendedMailNotifyModal from "../../../../../pages/Cabinet/components/ProfileEditModal/SendedMailNotifyModal";
import { displayError } from "../../../../services/Notifications/NotificationServices";

export default function UserEmailSection() {
    const { register, watch, formState } = useFormContext();
    const confirmButtonRef = useRef<HTMLButtonElement | null>(null);
    const [modalOpen, setModalOpen] = useState(false);

    const isEmailConfirmed = watch("email")?.is_confirmed;
    const isEmailFilled = watch("email")?.address;
    const isDirty = formState.dirtyFields.email_address;

    const emailStatus = !isDirty && (!isEmailConfirmed ?
        <img
            src={`${process.env.PUBLIC_URL}/ProfileEditModal/email_need_verify_notification.svg`}
            alt="Необходимо подтверждение почты"
            loading="lazy"
        /> :
        <img
            src={`${process.env.PUBLIC_URL}/ProfileEditModal/icon_confirmed.svg`}
            alt="Почта подтверждена"
            loading="lazy"
        />);

    const sendConfirm = async () => {
        try {
            const res = await axios.post(`/users/me/email-verification/`);
            if (res.status === 200) setModalOpen(true);
        } catch (e: unknown) {
            displayError((e as Error).message);
        }
    };

    const handleClick = async (
        e: MouseEvent<HTMLButtonElement> | KeyboardEvent<HTMLButtonElement>,
    ) => {
        e.preventDefault();

        const isEnter =
            e.type === "keydown" &&
            (e as KeyboardEvent).key === "Enter" &&
            document.activeElement === confirmButtonRef.current;

        if (e.type === "click" || isEnter) await sendConfirm();
    };

    return (
        <>
            {modalOpen && (
                <SendedMailNotifyModal
                    isOpen={modalOpen}
                    closeModal={() => setModalOpen(false)}
                />
            )}

            <div className="universaleditmodal-right-content-email-container">
                {isEmailFilled && (
                    <p className="universaleditmodal-right-content-email-label">
                        Электронная почта
                    </p>
                )}

                <Input
                    type="email"
                    grayStyle
                    placeholder="Почта"
                    className={`universaleditmodal-right-content-email-input${!isEmailFilled ? "-filled" : ""} ${formState.errors.email_address ? 'invalid' : ''}`}
                    rightElement={() => emailStatus}
                    rightElementStyle='email-status-notification-img'
                    {...register("email_address", {
                        pattern: {
                            value: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
                            message: "Некорректный email адрес",
                        },
                    })}
                />

                {formState.errors.email_address?.type === 'pattern' && (
                    <p className="universaleditmodal-right-content-invalid-message">
                        {formState.errors.email_address?.message?.toString()}
                    </p>
                )}

                {isEmailConfirmed === false && !isDirty && (
                    <div className="universaleditmodal-right-content-confirm-container">
                        <p className="universaleditmodal-right-content-need-confirm-email-notify">
                            Требуется подтверждение почты
                        </p>
                        <button
                            type="button"
                            ref={confirmButtonRef}
                            onClick={handleClick}
                            onKeyDown={handleClick}
                            className="universaleditmodal-right-content-confirm-email-button"
                        >
                            Подтвердить
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
